import { render, staticRenderFns } from "./mergeClientView.vue?vue&type=template&id=a4e24276&"
import script from "./mergeClientView.vue?vue&type=script&lang=js&"
export * from "./mergeClientView.vue?vue&type=script&lang=js&"
import style0 from "./mergeClientView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports